import type React from 'react';

import { useStepManageAccessMembers } from '@/hooks/manageAccess/useStepManageAccessMembers';
import StepInternalParticipantsView from '@/components/organism/CreateSix/steps/StepInternalParticipants/StepInternalParticipants.view';

export interface StepManageAccessMembersProps {
  onClose: () => void;
}

function StepManageAccessMembers(props: StepManageAccessMembersProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepManageAccessMembers();

  return (
    <StepInternalParticipantsView
      selectedMembers={state.selectedMembers}
      candidateMembers={state.candidateMembers}
      searchValue={state.searchValue}
      onSearchValueChange={handlers.handleSearchChange}
      onRemoveMember={handlers.handleRemoveMember}
      onAddMember={handlers.handleAddMember}
    />
  );
}

StepManageAccessMembers.displayName = 'StepManageAccessMembers';

export default StepManageAccessMembers;
